import { render, staticRenderFns } from "./LatePickups.vue?vue&type=template&id=b702e72a&scoped=true&"
import script from "./LatePickups.vue?vue&type=script&lang=js&"
export * from "./LatePickups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b702e72a",
  null
  
)

export default component.exports